function useStyles() {
    return {
        noResponse: {
            width: '100%',
            height: '100%',
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '20px 50px',
            '& .MuiTypography-root': {
                width: '100%',
                textAlign: 'center',
            },
            '& .MuiIcon-root': {
                fontSize: '45px',
                height: '45px',
                width: '45px',
                overflow: 'visible',
                color: 'c_grey.100',
                '& .MuiSvgIcon-root': {
                    fontSize: 'inherit',
                    height: 'inherit',
                    width: 'inherit',
                },
            },
        },
    }
}
export { useStyles }